import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gfu-issue__option-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-issue__option-icon-box"
}
const _hoisted_3 = { class: "gfu-issue__option-icon-box-icon-box-inner" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "gfu-issue__option-header" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "gfu-issue__option-subtitle"
}
const _hoisted_8 = { class: "gfu-issue__option-navigation-box" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "gfu-issue__option",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onHeaderClick && $options.onHeaderClick(...args)))
    }, [
      ($props.imageUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: $props.imageUrl,
                alt: $props.header
              }, null, 8 /* PROPS */, _hoisted_4)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: "gfu-issue__option-title",
          innerHTML: $options.formattedHeader
        }, null, 8 /* PROPS */, _hoisted_6),
        ($props.subtitle)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString($props.subtitle), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_base_icon, {
          name: "chevron-right",
          class: "gfu-issue__option-navigation-box-icon"
        })
      ])
    ])
  ]))
}